import React from "react";

interface DocDataGridSelectionContextValue {
  checkedItemIds: string[];
  isItemChecked: (id: string) => boolean;
  clearChecked: () => void;
}

export const DocDataGridSelectionContext =
  React.createContext<DocDataGridSelectionContextValue>({
    checkedItemIds: [],
    isItemChecked: () => false,
    clearChecked: () => {},
  });
